import {
    Button,
    Checkbox,
    TableCell,
    TableRow,
    Tooltip,
} from "@material-ui/core";
import { useState } from "react";
import moment from "moment/moment";
import { AREAS_USUARIOS, ESTADOS_BANDEJAS_SUSPENSION } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { changeEstadoSeguimiento, generateExcel, marcarLeidoCasoSuspension } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import ToolbarXLSPDF from "../compartidos/ToolbarXLSPDF";
import { CerrarCaso } from "./CerrarCaso";
import IconEstado from "../autorizaciones/UI/IconEstado";
import { CambioEstadoSolicitudComunicacion } from "./CambioEstadoSolicitudComunicacion";
import { MailOutline } from "@material-ui/icons";

export const SolicitudesComunicacionItem = (props) => {
    const dispatch = useDispatch();
    const { areas: areasUsuario } = useSelector((state) => state.auth);
    const tieneAreaAfiliaciones = areasUsuario.find((area) => area.idArea === AREAS_USUARIOS.NACIONAL);
    const { item } = props;
    const [openModalCambioEstado, setOpenModalCambioEstado] = useState(false);


    const selectedItem = (item) => {
        props.setItemSelect(item);
        props.setAbrirModalRespuesta(true);
        if ((tieneAreaAfiliaciones && !item.leidoAfiliaciones) || (!tieneAreaAfiliaciones && !item.leidoMesa)) {
            dispatch(marcarLeidoCasoSuspension(item.id, tieneAreaAfiliaciones ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA, false))
        }
    }
    
    console.log(item)
    return (
        <>
            {openModalCambioEstado && (
                <CambioEstadoSolicitudComunicacion
                    open={openModalCambioEstado}
                    closeModalHandler={() => {
                        setOpenModalCambioEstado(false);
                    }}
                    solicitud={item}
                    disabled={false}
                    tieneAreaAfiliaciones={tieneAreaAfiliaciones}
                />
            )}
            <TableRow style={{ background: ((tieneAreaAfiliaciones && !item.leidoAfiliaciones) || (!tieneAreaAfiliaciones && !item.leidoMesa)) && 'lightblue' }}>
                <TableCell
                    disabled={true}
                    align="center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        if ((tieneAreaAfiliaciones && item.leidoAfiliaciones) || (!tieneAreaAfiliaciones && item.leidoMesa)) {
                            dispatch(marcarLeidoCasoSuspension(item.id, tieneAreaAfiliaciones ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA, true))
                        }
                    }}>
                    <Tooltip
                        title={
                            <>
                                <span >
                                    {`Marcar como no leído`}
                                </span>
                            </>
                        }
                    >
                        <MailOutline />
                    </Tooltip>
                </TableCell>
                <TableCell disabled={true}
                    align="center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setOpenModalCambioEstado(true)}
                >
                    <IconEstado
                        useColorTable={true}
                        texto={item?.letraUrgente}
                        backgroundColor={item?.colorUrgente}
                        descripcion={item?.descripcionUrgente}

                    />
                </TableCell>
                <TableCell id='#fecha'>{moment(item.fecha).format("DD/MM/YYYY HH:MM")}</TableCell>
                <TableCell >{item.fechaUltimaRespuestaAfiliaciones ? moment(item.fechaUltimaRespuestaAfiliaciones).format("DD/MM/YYYY HH:MM") : "-"}</TableCell>
                <TableCell >{item.fechaUltimaRespuestaMesa ? moment(item.fechaUltimaRespuestaMesa).format("DD/MM/YYYY HH:MM") : "-"}</TableCell>
                <TableCell>{item.cuit}</TableCell>
                <TableCell>{item.denominacion}</TableCell>
                <TableCell>{item.nombreUsuario}</TableCell>
                <TableCell>{item.nombreUsuarioMesa}</TableCell>
                {

                    <TableCell><Button variant="contained" color="primary" onClick={() => selectedItem(item)}>{`${Number(props.estadoActual) === ESTADOS_BANDEJAS_SUSPENSION.CASOS_CERRADOS ? `Ver` : `Responder`}`}</Button></TableCell>

                }
                {
                    (tieneAreaAfiliaciones && Number(props.estadoActual) === ESTADOS_BANDEJAS_SUSPENSION.PENDIENTES) && (
                        <TableCell><CerrarCaso item={item} /></TableCell>
                    )
                }
                {
                    <ToolbarXLSPDF
                        handleExportExcel={() => dispatch(generateExcel(item.id))}
                    />
                }
                <TableCell>
                    <Checkbox
                        checked={item.seguimiento}
                        value={item.seguimiento}
                        name="seguimiento"
                        onClick={(e) => { dispatch(changeEstadoSeguimiento(item.id, e.target.checked,tieneAreaAfiliaciones))}}
                    />
                </TableCell>
            </TableRow>
        </>
    )
};